<template>
	<div class="mb-3">
		<div class="form-floating">
		<input 
			:type="type" 
			:name='name' 
			placeholder = 'placeholder' 
			:value="value"
			@input="$emit('input', $event.target.value)"
			:class="{ 
				'is-valid': validator && !validator.$error && validator.$dirty, 
				'is-invalid': validator && validator.$error,
				inputClass
			}"
			class ='form-control'
		/>
			<label :for="name" class="">{{ label }}</label>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			required: false
		},
		value: {
			type: [String],
			required: false
		},
		inputClass: {
			type: String,
			required: false
		},
		type: {
			type: String,
			default: 'text',
			validator(value) { return ['text', 'email', 'password', 'date'].includes(value) } 
		},
		validator: {
			type: Object,
			required: false,
			validator ($v) { return $v.hasOwnProperty('$model'); }
		}
	}
}
</script>